/**
 * Performs a list of async actions one after another (not in parallel)
 *
 * @example
 *   // Loads a list of users, one at a time.
 *   let queue = TmrSerialQ(users, (user, idx) => user.$get());
 *   // Cancels the queue
 *   queue.cancel();
 *
 * @alias TmrSerialQ
 * @type {ngFactory}
 * @param {array} arr The elements that will be passed in series to asyncAction
 * @param {Promise} asyncAction The asyncronous action. Accepts two arguments:
 *   the first is the passed element, the second is the current index
 * @return {Promise} The promise queue, cancelable with cancel().
 */
function TmrSerialQFactory() {
  'ngInject'
  return (arr, asyncAction) => {
    let cancel = false
    let queue = arr.reduce(
      (promise, element, idx) =>
        promise.then(() => (cancel ? null : asyncAction(element, idx))),
      Promise.resolve()
    )
    queue.cancel = () => (cancel = true)
    return queue
  }
}

export const factory = ['TmrSerialQ', TmrSerialQFactory]
